class Store {
  constructor(coverLetterStore) {
    this.coverLetter = coverLetterStore
  }
}

export default Store
